import {
  Component,
  Input,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { PdsSupplier } from '../../../shared/interfaces/buyer-response.interface';

@Component({
  selector: 'ps-ui-pds-label',
  templateUrl: './pds-label.component.html',
  styleUrls: ['./pds-label.component.css'],
})
export class PdsLabelComponent implements OnDestroy, AfterViewInit {
  static fees: PdsSupplier[];
  static feesLoaded: Observable<unknown>;
  private _subscriptions: Subscription = new Subscription();

  @ViewChild('tooltip') tooltip: ElementRef;

  @Input() companyId!: number;
  @Input() supplierId!: number;
  @Input() cpi?: number;
  @Input() top: boolean = false;
  @Input()
  public fee?: number;

  ngAfterViewInit(): void {
    if (this.top) {
      return;
    }
    this._subscriptions.add(
      this._createTooltipObserver().subscribe((entry) =>
        this._changeTooltipPosition(entry)
      )
    );
  }

  private _changeTooltipPosition(entry: IntersectionObserverEntry) {
    // change only when element is shown
    const isVisible = !!(entry.target as HTMLSpanElement).offsetParent;
    if (!isVisible) {
      // only not initialized as `top = true` tooltips change position
      // from that, everytime tooltip is hidden, reset default position
      this.top = false;
      return;
    }
    const footer = document.querySelector('.footer');
    const rect = footer?.getBoundingClientRect();
    const footerTop = rect?.top || 0;
    const invert =
      entry.intersectionRatio < 1 || entry.intersectionRect.bottom >= footerTop;
    if (invert) {
      this.top = !this.top;
    }
  }

  private _createTooltipObserver(): Observable<IntersectionObserverEntry> {
    return new Observable((observer) => {
      const intersectionObserver = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
          observer.next(entries[0]);
        }
      );

      intersectionObserver.observe(this.tooltip.nativeElement);

      return () => {
        intersectionObserver.disconnect();
      };
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
